import { Component, Input } from '@angular/core';
import { Event } from '@models/community/event.model';
import { NgIf } from '@angular/common';
import { CommonComponent } from '@components/common.component';
import { SimplebarAngularModule } from 'simplebar-angular';
import moment from 'moment/moment';
import { EventCardComponent } from '@calendar/components/event-card/event-card.component';
import { isFlagOn } from '@calendar/functions/rsvp-guest.functions';

@Component({
  selector: 'app-calendar-event-details',
  standalone: true,
  imports: [NgIf, SimplebarAngularModule, EventCardComponent],
  templateUrl: './calendar-event-details.component.html',
  styles: ``,
})
export class CalendarEventDetailsComponent extends CommonComponent {
  mm = moment;

  @Input() data: Event | null = null;
  @Input() type: 'COMMUNITY' | 'USER' = 'COMMUNITY';
  @Input() fromDetails = false;

  get detailsTitle(): string {
    return isFlagOn(this.data?.allowGuestsInd) ? 'RSVP w/Guest Event Details' : 'Event Details';
  }
}
